import * as React from "react"
import * as ReactDom from "react-dom"
import View from "../views/tapa"


export const page = () => {
  if (window.matchMedia("(min-width: 768px)").matches) {
    window.location.href = "/estadio-aguila"
  } else {
    ReactDom.render(<View /> , document.getElementById('app'))
  }
}